const state = {
	UserInfo: Object
};
const mutations = {
	SetUserInfo: (state: any, value: any) => {
		state.UserInfo = value;
	}
};

const actions = {};
const getters = {};
export default {
	state,
	actions,
	mutations,
	getters
};
